<template>
  <footer id="footer" v-if="!admin">
    <div class="container">
      <div class="row align-items-center text-center text-lg-left">
        <div class="col-lg-1 mb-4 mb-lg-0">
          <a href="/" class="footer-logo"></a>
        </div>
        <div class="col-lg-5 mb-4 mb-lg-0">
          <p class="copyright">Copyright &copy;{{ new Date().getFullYear() }} J.C. Steele and Sons, Inc. All rights reserved.</p>
        </div>
        <!-- Empty spacer column. Was col-lg-3 (paired with a
             col-lg-3 design-credit column on the right) but the
             credit text — "Website Design By J.C. Steele and
             Sons, Inc." — wrapped to two lines at typical
             viewport widths. Reduced to col-lg-2 here and
             enlarged the credit to col-lg-4 so the text fits on
             one line. Total still sums to 12. -->
        <div class="col-lg-2 mb-4 mb-lg-0">
        </div>
        <div class="col-lg-4">
          <p class="obx">Website Design By <a href="https://www.jcsteele.com" target="_blank">J.C. Steele and Sons, Inc.</a></p>
        </div>
      </div>
    </div>
  </footer>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  name: "Foot",
  computed: {
    ...mapGetters({ currentUser: "currentUser" }),
    // Reactive admin-route detection — see Head.vue's
    // computed admin() for full rationale. Foot.vue
    // persists across route changes (lives outside
    // <router-view>), so a data-field assignment in
    // mounted() doesn't update when the user navigates
    // between admin and customer routes via router-link.
    admin() {
      return !!(
        this.$route &&
        this.$route.matched &&
        this.$route.matched.length > 0 &&
        this.$route.matched[0].props &&
        this.$route.matched[0].props.default &&
        this.$route.matched[0].props.default.admin
      );
    }
  }
};
</script>

<style>
</style>